// // ProductCreate.tsx
// import React, {useContext, useRef, useState} from 'react';
// import {InputText} from 'primereact/inputtext';
// import {InputNumber, InputNumberValueChangeEvent} from 'primereact/inputnumber';
// import {InputTextarea} from 'primereact/inputtextarea';
// import {Button} from 'primereact/button';
// import {Dropdown, DropdownChangeEvent} from 'primereact/dropdown';
// import {FileUpload, FileUploadHeaderTemplateOptions, FileUploadUploadEvent} from 'primereact/fileupload';
// import {Divider} from 'primereact/divider';
// import {Toast} from 'primereact/toast';
// import {ConfirmDialog, confirmDialog} from 'primereact/confirmdialog';
// import {DropdownOption, KeyFact, ProductFormData, ProductPayload} from "../../../types/product";
// import {useFetch} from "../../../layout/hooks/useFetch";
// import callToast, {handleChangeData, handleDataUpdate, handleRemoveRow} from "../../../utils/helper";
// import Label from "../../../Component/Label";
// import PageHeading from "../../../Component/PageHeading";
// import {baseUrl} from "../../../utils/webInfo";
// import {LayoutContext} from "../../../layout/context/LayoutContext";
// import {IidName} from "../../../interfaces/interfaces";
// import {useNavigate} from "react-router-dom";
//
//
// const ProductCreate: React.FC = () => {
//     const toast = useRef<Toast>(null);
//     const navigate = useNavigate();
//     const [keyFacts, setKeyFacts] = useState<KeyFact[]>([{id:1,title: '', description: ''}]);
//     const {data: productCategory} = useFetch('/api/product_category?page=0&size=100');
//     const {data: pregnancyLevel} = useFetch('/api/pregnancy_level?page=0&size=100');
//     const {data: dosageForm} = useFetch('/api/product_dosage_form?page=0&size=100&sort=name');
//
//     const [selectedProductCategory, setSelectedProductCategory] = useState<IidName| null>(null);
//     const [selectedPregnancyLevel, setSelectedPregnancyLevel] = useState<IidName| null>(null);
//     const [selectedProductDosage, setSelectedProductDosage] = useState<IidName| null>(null);
//
//     const [formDataState, setFormDataState] = useState<ProductFormData>({
//         productCode: '',
//         composition: '',
//         indication: '',
//         dosage: '',
//         packSize: '',
//         image_file: null,
//         brandName: '',
//         genericName: '',
//         strength: null,
//         mrp: null,
//         tradePriceVat: null,
//         offerPrice: null,
//         description: '',
//         discountPrice: null
//     });
//
//     console.log("formData", formDataState)
//
//
//     // const pregnancyLevelOptions: DropdownOption[] = [
//     //     { label: 'Level 1', value: 1 },
//     //     { label: 'Level 2', value: 2 },
//     //     { label: 'Level 18', value: 18 }
//     // ];
//
//     const dosageFormOptions: DropdownOption[] = [
//         {label: 'Tablet', value: 17},
//         {label: 'Capsule', value: 18},
//         {label: 'Syrup', value: 19}
//     ];
//
//
//
//
//     const handlePlus = (): void => {
//         setKeyFacts([...keyFacts, {id:Date.now(), title: '', description: ''}]);
//     };
//
//     const removeKeyFact = (index: number): void => {
//         if (keyFacts.length > 1) {
//             const updatedKeyFacts = keyFacts.filter((_, i) => i !== index);
//             setKeyFacts(updatedKeyFacts);
//         }
//     };
//
//     const confirmRemoveKeyFact = (index: number): void => {
//         confirmDialog({
//             message: 'Are you sure you want to delete this key fact?',
//             header: 'Confirmation',
//             icon: 'pi pi-exclamation-triangle',
//             accept: () => removeKeyFact(index),
//             reject: () => {
//             }
//         });
//     };
//
//     const {accessToken} = useContext(LayoutContext);
//
//     // const onUpload = (event: FileUploadUploadEvent): void => {
//     //     const files = (event as any).files || event.files;
//     //     if (files && files.length > 0) {
//     //         setFormDataState(prev => ({
//     //             ...prev,
//     //             image_file: files[0]
//     //         }));
//     //     }
//     // };
//
//     const handleSubmit = async (e: React.FormEvent<HTMLFormElement>, id?: number) => {
//         e.preventDefault();
//
//
//         if(!selectedProductCategory?.id){
//             return
//         }
//         // Create FormData object
//         const formData: any = new FormData();
//
//         // Append basic form fields
//         formData.append('brandName', formDataState.brandName || '');
//         formData.append('genericName', formDataState.genericName || '');
//         formData.append('productCode', formDataState.productCode || '');
//         formData.append('composition', formDataState.composition || '');
//         formData.append('indication', formDataState.indication || '');
//         formData.append('dosage', formDataState.dosage || '');
//         formData.append('packSize', formDataState.packSize || '');
//         formData.append('strength', String(formDataState.strength || ''));
//         formData.append('description', formDataState.description || '');
//         formData.append('mrp', String(formDataState.mrp || ''));
//         formData.append('tradePriceVat', String(formDataState.tradePriceVat || ''));
//         formData.append('offerPrice', String(formDataState.offerPrice || ''));
//         formData.append('discountPrice', String(formDataState.discountPrice || ''));
//         // formData.append('image_file', String(formDataState.image_file || ''));
//         selectedProductCategory?.id && formData.append('productCategoryId', selectedProductCategory?.id);
//         selectedPregnancyLevel?.id && formData.append('pregnancyLevelId', selectedPregnancyLevel?.id);
//         selectedProductDosage?.id && formData.append('productDosageFormId', selectedProductDosage?.id);
//
//         // Append image file if exists
//         if (formDataState.image_file) {
//             formData.append('image_file', formDataState.image_file);
//         }
//
//         // if (selectedProductCategory?.id) {
//         //     formData.append('productCategoryId', selectedProductCategory?.id);
//         // }
//         // if (selectedPregnancyLevel?.id) {
//         //     formData.append('pregnancyLevel', selectedPregnancyLevel?.id);
//         // }
//         // if (formDataState.productDosageFormId) {
//         //     formData.append('productDosageFormId', formDataState.productDosageFormId?.id);
//         // }
//
//         // Append key facts as JSON string (better for nested data)
//         if (keyFacts && keyFacts.length > 0) {
//             // Option 1: Send as JSON string
//             // formData.append('keyFacts', JSON.stringify(keyFacts));
//             // Option 2: Or flatten them as separate fields (uncomment if needed)
//             keyFacts.forEach((fact, index) => {
//                 formData.append(`keyFactTitle`, fact.title);
//                 formData.append(`keyFactDescription`, fact.description);
//             });
//         }
//
//         try {
//             const url = id? `${baseUrl.url}/api/product/${id}`:`${baseUrl.url}/api/product`;
//             const method = id ? "PUT" : "POST";
//             const res = await fetch(url, {
//                 method: method,
//                 headers: {
//                     "Authorization": `Bearer ${accessToken}`
//                 },
//                 body: formData
//             });
//
//             if (res.status === 304) {
//                 callToast(toast, "warn", "No data changed");
//                 return;
//             }
//
//             if (res.ok) {
//                 callToast(toast, "success", `Product ${id ? "updated" : "created"} successfully`);
//                 navigate('/product')
//             } else {
//                 const resData = await res.json();
//                 const { errors, message } = resData;
//                 callToast(toast, "error", errors?.[0] || message || "Something went wrong");
//             }
//         } catch (error: any) {
//             console.log("error", error.message);
//             callToast(toast, "error", "Network error occurred");
//         }
//     };
//
//
//
//
//     const emptyTemplate = () => {
//         return (
//             <div className="h-[10px] w-[10px] m-1 border-round">
//                 <div className="flex flex-column w-full h-full justify-content-center align-items-center cursor-pointer"
//                 >
//                     {formDataState.image_file ? (
//                         <div className="p-fileupload-preview">
//                             <img
//                                 alt="Default"
//                                 src={`${baseUrl?.url}/${formDataState.image_file}`}
//                                 height="140"
//                             />
//                         </div>
//                     ) : (
//                         <>
//                             <i className="pi pi-image mt-3 p-5" style={{
//                                 fontSize: '5em',
//                                 borderRadius: '50%',
//                                 backgroundColor: 'var(--surface-b)',
//                                 color: 'var(--surface-d)'
//                             }}></i>
//                             <span style={{fontSize: '1.2em', color: 'var(--text-color-secondary)'}} className="my-5">
//                                  Drag and Drop Image Here
//                             </span>
//                         </>
//                     )}
//                 </div>
//             </div>
//         );
//     };
//
//     const onMetaTemplateSelect = (e: any) => {
//         // setTotalSize_meta(totalSize_meta);
//         setFormDataState(prev => ({
//             ...prev,
//             image_file: e.files[0],
//         }));
//     };
//
//     const headerTemplate = (options: FileUploadHeaderTemplateOptions) => {
//         const {className, chooseButton, cancelButton} = options;
//         return (
//             <div className={className}>
//                 <div className={'flex align-items-center gap-4'}>
//                     {chooseButton}
//
//                     {cancelButton}
//                 </div>
//             </div>
//         );
//     };
//
//     return (
//         <div className="card">
//             <PageHeading title={'Create Product'} back/>
//             <Toast ref={toast}/>
//             <ConfirmDialog/>
//
//             <form onSubmit={handleSubmit}>
//                 <div className="grid p-fluid">
//                     <div className={'col-12'}>
//                         <div className="grid">
//                             <div className=" col-12 md:col-4 xl:col-3">
//                                 <Label label={'Product Category'} required={true}/>
//                                 <Dropdown
//                                     id="productCategoryId"
//                                     value={selectedProductCategory}
//                                     options={productCategory}
//                                     // onChange={(e: DropdownChangeEvent) => handleInputChange(e, 'productCategoryId')}
//                                     // onChange={(e: DropdownChangeEvent) => handleChangeData('productCategoryId', e.target.value, formDataState, setFormDataState)}
//                                     onChange={(e: DropdownChangeEvent) => setSelectedProductCategory(e.target.value)}
//                                     placeholder="Select Category"
//                                     optionLabel='name'
//                                     className="w-full"
//                                     showClear
//                                 />
//                             </div>
//                             <div className=" col-12 md:col-4 xl:col-3">
//                                 <Label label={'Pregnancy Level'} required={true}/>
//                                 <Dropdown
//                                     id="pregnancyLevel"
//                                     value={selectedPregnancyLevel}
//                                     options={pregnancyLevel}
//                                     // onChange={(e: DropdownChangeEvent) => handleChangeData('pregnancyLevel', e.target.value, formDataState, setFormDataState)}
//                                     onChange={(e: DropdownChangeEvent) => setSelectedPregnancyLevel(e.target.value)}
//                                     placeholder="Select Level"
//                                     optionLabel='name'
//                                     className="w-full"
//                                     showClear
//                                 />
//                             </div>
//                             <div className=" col-12 md:col-4 xl:col-3">
//                                 <Label label={'Dosage Form'} required={true}/>
//                                 <Dropdown
//                                     id="productDosageFormId"
//                                     value={selectedProductDosage}
//                                     options={dosageForm}
//                                     // onChange={(e: DropdownChangeEvent) => handleChangeData('productDosageFormId', e.target.value, formDataState, setFormDataState)}
//                                     onChange={(e: DropdownChangeEvent) => setSelectedProductDosage(e.target.value)}
//                                     placeholder="Select Dosage Form"
//                                     optionLabel='name'
//                                     className="w-full"
//                                     showClear
//                                 />
//                             </div>
//
//                         </div>
//                     </div>
//                     <div className=" col-12 md:col-4 xl:col-3">
//                         <Label label={'Brand Name'} required={true}/>
//                         <InputText
//                             id="brandName"
//                             value={formDataState.brandName}
//                             onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeData('brandName', e.target.value, formDataState, setFormDataState)}
//                             placeholder="Enter brand name"
//                         />
//                     </div>
//                     <div className=" col-12 md:col-4 xl:col-3">
//                         <Label label={'Generic Name'} required={true}/>
//                         <InputText
//                             id="genericName"
//                             value={formDataState.genericName}
//                             onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeData('genericName', e.target.value, formDataState, setFormDataState)}
//                             placeholder="Enter generic name"
//                         />
//                     </div>
//                     <div className=" col-12 md:col-4 xl:col-2">
//                         <Label label={'Product Code'} required={true}/>
//                         <InputText
//                             id="productCode"
//                             value={formDataState.productCode}
//                             onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeData('productCode', e.target.value, formDataState, setFormDataState)}
//                             placeholder="Enter product code"
//                         />
//                     </div>
//                 </div>
//
//
//                 {/* Product Details Section */}
//                 <div className="grid p-fluid mt-1">
//                     <div className=" col-12 lg:col-7 xl:col-5">
//                         <Label label={'Composition'} required={true}/>
//                         <InputTextarea
//                             id="composition"
//                             value={formDataState.composition}
//                             onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => handleChangeData('composition', e.target.value, formDataState, setFormDataState)}
//                             rows={3}
//                             placeholder="Enter composition details"
//                             className="w-full"
//                         />
//                     </div>
//
//                     <div className="col-12">
//                         <div className="grid">
//                             <div className=" col-12 lg:col-7 xl:col-5">
//                                 <Label label={'Indication'} required={true}/>
//                                 <InputTextarea
//                                     id="indication"
//                                     value={formDataState.indication}
//                                     onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => handleChangeData('indication', e.target.value, formDataState, setFormDataState)}
//                                     rows={3}
//                                     placeholder="Enter indications"
//                                     className="w-full"
//                                 />
//                             </div>
//                         </div>
//                     </div>
//
//                     <div className="col-12">
//                         <div className="grid">
//                             <div className=" col-12 lg:col-7 xl:col-5">
//                                 <Label label={'Dosage'} required={true}/>
//                                 <InputTextarea
//                                     id="dosage"
//                                     value={formDataState.dosage}
//                                     onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => handleChangeData('dosage', e.target.value, formDataState, setFormDataState)}
//                                     rows={2}
//                                     placeholder="Enter dosage instructions"
//                                     className="w-full"
//                                 />
//                             </div>
//                         </div>
//                     </div>
//
//                     <div className="col-12">
//                         <div className="grid">
//                             <div className="field col-12 md:col-4 xl:col-2">
//                                 <Label label={'Pack Size'} required={true}/>
//                                 <InputText
//                                     id="packSize"
//                                     value={formDataState.packSize}
//                                     onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeData('packSize', e.target.value, formDataState, setFormDataState)}
//                                     placeholder="e.g., 4×10g"
//                                 />
//                             </div>
//
//                             <div className="field col-12 md:col-4 xl:col-2">
//                                 <Label label={'Strength'} required={true}/>
//                                 <InputNumber
//                                     id="strength"
//                                     value={formDataState.strength}
//                                     onValueChange={(e: InputNumberValueChangeEvent) => handleChangeData('strength', e.value, formDataState, setFormDataState)}
//                                     placeholder="Enter strength"
//                                     className="w-full"
//                                 />
//                             </div>
//                         </div>
//                     </div>
//
//                     <div className="field col-12 lg:col-7 xl:col-5">
//                         <Label label={'Description'} required={true}/>
//                         <InputTextarea
//                             id="description"
//                             value={formDataState.description}
//                             onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => handleChangeData('description', e.target.value, formDataState, setFormDataState)}
//                             rows={4}
//                             placeholder="Enter product description"
//                             className="w-full"
//                         />
//                     </div>
//                 </div>
//
//
//                 {/* Pricing Section */}
//                 <div className="grid p-fluid">
//                     <div className="field col-12 md:col-3 xl:col-2">
//                         <Label label={'MRP'} required={true}/>
//                         <InputNumber
//                             id="mrp"
//                             value={formDataState.mrp}
//                             onValueChange={(e: InputNumberValueChangeEvent) => handleChangeData('mrp', e.value, formDataState, setFormDataState)}
//                             mode="currency"
//                             currency="BDT"
//                             locale="bn-BD"
//                             placeholder="Enter MRP"
//                             className="w-full"
//                         />
//                     </div>
//
//                     <div className="field col-12 md:col-3 xl:col-2">
//                         <Label label={'Trade Price (with VAT)'} required={true}/>
//                         <InputNumber
//                             id="tradePriceVat"
//                             value={formDataState.tradePriceVat}
//                             onValueChange={(e: InputNumberValueChangeEvent) => handleChangeData('tradePriceVat', e.value, formDataState, setFormDataState)}
//                             mode="currency"
//                             currency="BDT"
//                             locale="bn-BD"
//                             placeholder="Enter trade price"
//                             className="w-full"
//                         />
//                     </div>
//
//                     <div className="field col-12 md:col-3 xl:col-2">
//                         <Label label={'Offer Price'} required={true}/>
//                         <InputNumber
//                             id="offerPrice"
//                             value={formDataState.offerPrice}
//                             onValueChange={(e: InputNumberValueChangeEvent) => handleChangeData('offerPrice', e.value, formDataState, setFormDataState)}
//                             mode="currency"
//                             currency="BDT"
//                             locale="bn-BD"
//                             placeholder="Enter offer price"
//                             className="w-full"
//                         />
//                     </div>
//
//                     <div className="field col-12 md:col-3 xl:col-2">
//                         <Label label={'Discount Price'} required={true}/>
//                         <InputNumber
//                             id="discountPrice"
//                             value={formDataState.discountPrice}
//                             onValueChange={(e: InputNumberValueChangeEvent) => handleChangeData('discountPrice', e.value, formDataState, setFormDataState)}
//                             mode="currency"
//                             currency="BDT"
//                             locale="bn-BD"
//                             placeholder="Enter discount price"
//                             className="w-full"
//                         />
//                     </div>
//                 </div>
//
//                 <div className="grid mt-1 ">
//                     <div className="col-12 xl:col-6 border border-1 border-round border-gray-300 p-3 ml-2 ">
//                         <div className={"flex gap-3 align-items-center mb-3"}>
//                             <div className={"text-600 text-base font-semibold"}>Key Facts</div>
//                             <Button type={"button"} icon="pi pi-plus" outlined size={"small"}
//                                     className={"w-2rem h-2rem"}
//                                     onClick={handlePlus}/>
//                         </div>
//                         {
//                             keyFacts?.map((fact, index: number) => {
//                                 const {id} = fact;
//
//                                 return <div key={index}
//                                             className={`my-2 border-1 border-300 py-4 px-3 border-round-md relative `}>
//                                     {keyFacts?.length > 1 &&
//                                         <Button type={"button"}
//                                                 onClick={() => handleRemoveRow(id, keyFacts, setKeyFacts)}
//                                                 icon="pi pi-times" rounded text severity="danger"
//                                                 aria-label="Cancel"
//                                                 className={"absolute right-0"} style={{top: "-3px"}}
//                                                 size={"small"}/>}
//
//                                     <div className="grid">
//                                         <div className='col-12 md:col-6'>
//                                             <label htmlFor={`keyFactTitle-${index}`}>Title</label>
//                                             <InputText
//                                                 id={`keyFactTitle-${index}`}
//                                                 value={fact.title}
//                                                 onChange={(e) => {
//                                                     handleDataUpdate(id, e.target.value, keyFacts, setKeyFacts, "title")
//                                                 }}
//                                                 placeholder={`Enter key fact ${index + 1} title`}
//                                                 className="w-full"
//                                             />
//                                         </div>
//
//                                         <div className="col-12  md:col-6">
//                                             <label htmlFor={`keyFactDescription-${index}`}>Description</label>
//                                             <InputText
//                                                 id={`keyFactDescription-${index}`}
//                                                 value={fact.description}
//                                                 onChange={(e) => {
//                                                     handleDataUpdate(id, e.target.value, keyFacts, setKeyFacts, "description")
//                                                 }}
//                                                 placeholder={`Enter key fact ${index + 1} description`}
//                                                 className="w-full"
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
//                             })
//                         }
//                     </div>
//                 </div>
//
//                 {/* Image Upload Section */}
//                 <div className="grid mt-3">
//                     <div className="field col-12 md:col-6 xl:col-4">
//                         <FileUpload
//                             name="image_file"
//                             accept="image/*"
//                             maxFileSize={1000000}
//                             // onUpload={onUpload}
//                             chooseLabel="Select Image"
//                             onSelect={onMetaTemplateSelect}
//                             // cancelLabel="Cancel"
//                             // uploadLabel="Upload"
//                             customUpload
//                             className="w-full"
//                             headerTemplate={headerTemplate}
//                             emptyTemplate={emptyTemplate}
//                         />
//                         {formDataState.image_file && (
//                             <div className="mt-2">
//                                 <small className="text-green-600">
//                                     Selected: {formDataState.image_file.name}
//                                 </small>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//
//                 {/* Submit Buttons */}
//                 <div>
//                     <Button
//                         type="submit"
//                         label="Create Product"
//                         icon="pi pi-check"
//                         className="p-button-primary"
//                         // disabled={!isFormValid()}
//                     />
//                 </div>
//             </form>
//         </div>
//     );
// };
//
// export default ProductCreate;


import React from 'react';
import CommonProduct from "../Component/CommonProduct";

const ProductCreate = () => {
    return (
        <div>
            <CommonProduct/>
        </div>
    );
};

export default ProductCreate;